



































import { Component, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';

@Component
export default class Navigation extends Vue {
  @Getter public isAuthenticated: boolean;
  @Getter public userFunds: number;

  logout(): void {
    this.$store.dispatch('logout')
  }
}
